var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPool = function SvgPool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5V4.75C18 3.7835 17.2165 3 16.25 3V3C15.2835 3 14.5 3.7835 14.5 4.75V12",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5V4.75C9.5 3.7835 8.7165 3 7.75 3V3C6.7835 3 6 3.7835 6 4.75V12",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.2406C3.68284 16.0956 4.39467 15.9909 5 16.0006C6.71208 16.0282 7.62115 17 9.33333 17C11.1251 17 12.7276 16.0618 14.5 16C16.2148 15.9402 17.6494 16.9988 19.3333 16.9988C19.8398 16.9988 20.4258 16.9113 21 16.7881",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.7657C17.1094 20.4702 15.5076 20 14.3333 20C12.6212 20 11.725 20.9848 10 20.9997C8.41651 21.0135 6.94837 20.5246 6 20.2236",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9.5H6",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgPool;